export class DescontoAcrescimoFormModel {
    constructor(
        public vPorcentagem: number | string | null = null,
        public vValorFixo: number | string | null = null,
        public tpCampo: number = 0,
    ) { }
}